// Accordion
// props
//   - wholeClickable: boolean 全体をクリックして開閉できるようにするかどうか，デフォルトはfalse
//   - showToggleBtn: boolean 開閉ボタンのアイコンを表示するかどうか，デフォルトはtrue
//   - iconClass: string 開閉ボタンのアイコン用のfont-awesome class, up/downに対応している必要がある．
import React, { memo, useCallback, useState } from "react";

const Accordion = memo(({
  wholeClickable=false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(props.isOpen || false);
  const toggleIsOpen = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  return (
    <DefaultAccordion
      {...props}
      isOpen={isOpen}
      toggleIsOpen={toggleIsOpen}
      wholeClickable={wholeClickable}
    />
)});

const DefaultAccordion = memo(props => {
  return (
    <>
      <div className={props.className} onClick={props.wholeClickable ? props.toggleIsOpen : () => {}}>
        {props.children[0]}
        {(props.showToggleBtn || !props.wholeClickable) &&
          <span className="jsAcd acdBtn" onClick={props.toggleIsOpen}>
            <i className={`fa fa-${props.iconClass || 'caret'}-${props.isOpen ? 'up' : 'down'}`}></i>
          </span>
        }
      </div>
      {props.isOpen && props.children[1]}
    </>
  )
});

export default Accordion;